
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"21","viewBox":"0 0 21 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21 15.6567V19.782C21.0001 20.0774 20.8882 20.3618 20.6869 20.5779C20.4855 20.794 20.2097 20.9257 19.915 20.9463C19.4056 20.9821 18.9894 21 18.6667 21C8.35683 21 0 12.6432 0 2.33333C0 2.01133 0.0178889 1.59522 0.0536667 1.085C0.0743428 0.790351 0.206011 0.514513 0.422104 0.313144C0.638197 0.111775 0.922627 -0.000133505 1.218 2.99343e-07H5.34333C5.48805 -0.000146224 5.62765 0.0535022 5.73502 0.150524C5.84239 0.247546 5.90986 0.381013 5.92433 0.525C5.95078 0.792556 5.97567 1.00722 5.999 1.169C6.23084 2.78708 6.70599 4.36081 7.40833 5.83683C7.51917 6.07017 7.44683 6.349 7.23683 6.49833L4.71917 8.29733C6.25883 11.884 9.11718 14.7423 12.7038 16.282L14.5005 13.769C14.5736 13.666 14.6808 13.592 14.8031 13.5602C14.9254 13.5284 15.0549 13.5408 15.169 13.5952C16.6449 14.2962 18.2182 14.7702 19.8357 15.001C19.9974 15.0243 20.2113 15.0492 20.4773 15.0757C20.6211 15.0904 20.7543 15.158 20.8511 15.2653C20.9479 15.3727 21.0002 15.5121 21 15.6567Z","fill":"white"}})])
          )
        }
      }
    